module.exports = __webpack_public_path__ + "static/img/game13_icon.f78d4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/game13_icon.png
// module id = NMpJ
// module chunks = 0